type LogoProps = {
  inverted?: boolean;
};

export function Logo({ inverted = false }: LogoProps) {
  return (
    <a
      className={`logo${inverted ? " logo--inverted" : ""}`}
      href="/"
      aria-label="Kratis home"
    >
      <svg className="logo__mark" viewBox="0 0 64 64" aria-hidden="true">
        <path
          className="logo__k"
          d="M6 4h14v23L43 4h19L32 34l31 26H43L20 40v20H6Z"
        />
        <path className="logo__facet" d="m20 27 12 7-12 10Z" />
      </svg>
      <span className="logo__word" aria-hidden="true">
        RATIS
      </span>
    </a>
  );
}
